// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.rentercontact.RentalManagerRenterContactWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerRenterContactGetLikelyTenantsRequestDto,
  RentalManagerRenterContactGetLikelyTenantsResponseDto,
  RentalManagerRenterContactGetTenanciesRequestDto,
  RentalManagerRenterContactGetTenanciesResponseDto,
  RentalManagerRenterContactGetTenantsRequestDto,
  RentalManagerRenterContactGetTenantsResponseDto,
} from '../..';

export const RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path =
  '/api/web/v1/users/renterContact/getLikelyTenants';

/**
 * Get likely tenants, sorted by probability of being a current tenant
 */
export const RentalManagerRenterContactWebApiHandler_getLikelyTenants = (
  postData: RentalManagerRenterContactGetLikelyTenantsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterContactGetLikelyTenantsRequestDto,
    RentalManagerRenterContactGetLikelyTenantsResponseDto
  >(
    {
      endpoint: RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerRenterContactWebApiHandler_getTenancies_Path = '/api/web/v1/users/renterContact/getTenancies';

/**
 * Get tenancies, sorted by earliest tenancy start date, then tenant last name
 */
export const RentalManagerRenterContactWebApiHandler_getTenancies = (
  postData: RentalManagerRenterContactGetTenanciesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterContactGetTenanciesRequestDto,
    RentalManagerRenterContactGetTenanciesResponseDto
  >(
    {
      endpoint: RentalManagerRenterContactWebApiHandler_getTenancies_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerRenterContactWebApiHandler_getTenants_Path = '/api/web/v1/users/renterContact/getTenants';

/**
 * Get tenants grouped by tenant with their tenancies
 */
export const RentalManagerRenterContactWebApiHandler_getTenants = (
  postData: RentalManagerRenterContactGetTenantsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterContactGetTenantsRequestDto,
    RentalManagerRenterContactGetTenantsResponseDto
  >(
    {
      endpoint: RentalManagerRenterContactWebApiHandler_getTenants_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
